import { forwardRef } from 'react';

import Box from '@mui/material/Box/Box';

import './styles.scss';

interface BraintreeInputField {
  label: string;
  errorMessage?: string;
}

export const BraintreeInputField = forwardRef(
  ({ label, errorMessage = '' }: BraintreeInputField, ref) => {
    return (
      <Box flex={1}>
        {label && (
          <label className="s-label" htmlFor={label}>
            {label}
          </label>
        )}
        <div
          id={label}
          ref={ref as any}
          className={`s-input braintree-hosted-fields-input large ${errorMessage ? 'invalid' : ''}`}
        />
        {errorMessage && <p className="p-FieldError Error">{errorMessage}</p>}
      </Box>
    );
  }
);

BraintreeInputField.displayName = 'BraintreeInputField';
